import { Component, inject, OnInit } from '@angular/core';
import { OrbitFormClaimService } from '../services/orbit-form-claim.service';

@Component({
  selector: 'lib-engineer-booking.component',
  standalone: true,
  providers: [],
  imports: [],
  templateUrl: './engineer-booking.component.html',
  styleUrl: './engineer-booking.component.scss',
})
export class EngineerBookingComponent implements OnInit {
  formService = inject(OrbitFormClaimService);

  bookingOptions = this.formService.state.engineerBookingDetails();

  getEarliestDate() {
    return null;
  }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
